import React, { ReactNode } from 'react';

import { Button, TitleWithDescription } from '@infoods/lifebase-ui';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import classNames from 'classnames';

import classes from './HelpCenterResourceRow.module.scss';

type HelpCenterResourceRowProps = {
  title: string;
  description: string;
  /** icon should have color inherit prop  */
  icon: ReactNode;
  iconColor: 'warning' | 'error' | 'success' | 'violet';
  onClick: () => void;
};

const HelpCenterResourceRow = ({
  title,
  description,
  icon,
  iconColor,
  onClick,
}: HelpCenterResourceRowProps) => (
  <div className={classes.resourceRow}>
    <Button variant="unstyled" className={classes.resourceRowButton} onClick={onClick}>
      <div className={classNames(classes.iconContainer, classes[iconColor])}>{icon}</div>
      <TitleWithDescription
        title={title}
        titleFont="title-16-bold"
        description={description}
        descriptionColor="neutral-600"
        fullWidth
      />
      <ChevronRightRoundedIcon
        className={classes.endIcon}
        color="inherit"
        fontSize="large"
      />
    </Button>
  </div>
);

export { HelpCenterResourceRow };
